export const useEncrypt = (key: string, value: any) => {
    let encodedString = window.btoa(value)
    return localStorage.setItem(key, encodedString)
}
